/**
 * News component
 *
 * Funktionen für News-Beiträge.
 */

/**
 * Durch einen Klick auf einen News-Beitrag wird automatisch der Link zur
 * Detailseite aufgerufen.
 */
function linkNewsBox() {
    document.querySelectorAll('.linked-news-post').forEach((newsItem) => {
        newsItem.addEventListener('click', (e) => {
            // Wenn das geklickte Element ein Link ist, wird abgebrochen
            if (e.target instanceof HTMLElement && e.target.closest('a')) {
                return;
            }

            // Sonst wird der Link aufgerufen
            newsItem.querySelector('p.more a')?.click();
        });
    });
}

document.addEventListener('DOMContentLoaded', () => {
    linkNewsBox();
});
